<template>
  <ra-card>
    <template slot="header">
      <p>Invitations</p>
    </template>
    <template slot="content">
      <el-row v-if="invites.length" type="flex" :gutter="60">
        <el-col :md="12">
          <div class="ra-invite--image">
            <img :src="getImage('invite.svg')" alt="" />
            <p>You have {{ invites.length }} pending invites</p>
          </div>
        </el-col>
        <el-col :md="12">
          <el-carousel
            class="ra-invite--slider"
            :interval="5000"
            arrow="always"
            :autoplay="false"
            :loop="false"
            :trigger="'click'"
          >
            <el-carousel-item v-for="invite in invites" :key="invite.id">
              <div class="invite">
                <span>{{
                  invite.organisation && invite.organisation.name.charAt(0)
                }}</span>
                <h6>{{ invite.organisation && invite.organisation.name }}</h6>
                <!--                <p>{{ invite.role }}</p>-->
                <div class="actions">
                  <el-button
                    type="text"
                    size="small"
                    :loading="declining"
                    :disabled="
                      !userCan('auth', 'organisation.acceptinvitation')
                    "
                    @click="inviteAction(invite.organisation.id, 'decline')"
                    >Decline</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    :loading="accepting"
                    :disabled="
                      !userCan('auth', 'organisation.declineinvitation')
                    "
                    @click="inviteAction(invite.organisation.id, 'accept')"
                    >Accept</el-button
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row v-else type="flex">
        <el-col :span="24">
          <div class="ra-invite--image empty">
            <img :src="getImage('invite.svg')" alt="" />
            <p>You have no pending invites</p>
          </div>
        </el-col>
      </el-row>
    </template>
  </ra-card>
</template>

<script>
import inviteMixin from "@/mixins/invite";

export default {
  name: "OrganisationInvites",
  mixins: [inviteMixin]
};
</script>

<style lang="scss" scoped>
.ra-invite--image {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    color: var(--ra-grey-tertiary);
  }

  &.empty {
    height: auto;
    margin: 20px 0;
  }
}

.ra-invite--slider {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: scroll;

  .invites {
    display: flex;
    align-items: center;
    position: relative;
  }

  .invite {
    width: 80%;
    margin: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 30px;
    text-align: center;

    span {
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 15px;
      background: #f5f5f5;
      border-radius: 40px;
    }

    h6 {
      font-size: 1rem;
      font-weight: 500;
    }

    p {
      font-size: 0.75rem;
      color: var(--ra-grey-tertiary);
    }

    .actions {
      margin-top: 40px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
